/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import { List, SiteMcpServer, SiteMcpServerHeaders, SiteMcpServerName, URL } from "./data-contracts";

/**
 * No description
 * @tags site-mcp-servers
 * @name ListSiteMcpServers
 * @summary List all MCP servers for a site
 * @request GET:/orgs/{organizationId}/sites/{siteId}/mcp-servers
 * @secure
 */

// @ts-ignore
export const listSiteMcpServers: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: SiteMcpServer[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/mcp-servers",
  method: "get",
  streaming: false,
  tags: ["site-mcp-servers"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags site-mcp-servers
 * @name CreateSiteMcpServer
 * @summary Create a new MCP server
 * @request POST:/orgs/{organizationId}/sites/{siteId}/mcp-servers
 * @secure
 */

// @ts-ignore
export const createSiteMcpServer: {
  route: string;
  method: "post";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /** Name of the MCP server */
    name: SiteMcpServerName;
    url: URL;
    /** HTTP headers sent with requests to this server */
    headers: SiteMcpServerHeaders;
  };
  RequestHeaders: {};
  ResponseBody: SiteMcpServer;
  ResponseStatusCode: 201;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/mcp-servers",
  method: "post",
  streaming: false,
  tags: ["site-mcp-servers"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags site-mcp-servers
 * @name GetSiteMcpServerById
 * @summary Get a site MCP server
 * @request GET:/orgs/{organizationId}/sites/{siteId}/mcp-servers/{siteMcpServerId}
 * @secure
 */

// @ts-ignore
export const getSiteMcpServerById: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the site */
    siteId: string;
    /** The unique id of the MCP server */
    siteMcpServerId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: SiteMcpServer;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/mcp-servers/{siteMcpServerId}",
  method: "get",
  streaming: false,
  tags: ["site-mcp-servers"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags site-mcp-servers
 * @name UpdateSiteMcpServerById
 * @summary Update a site MCP server
 * @request PATCH:/orgs/{organizationId}/sites/{siteId}/mcp-servers/{siteMcpServerId}
 * @secure
 */

// @ts-ignore
export const updateSiteMcpServerById: {
  route: string;
  method: "patch";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the site */
    siteId: string;
    /** The unique id of the MCP server */
    siteMcpServerId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /** Name of the MCP server */
    name?: SiteMcpServerName;
    /**
     * @format uri
     * @maxLength 2048
     */
    url?: string;
    /** HTTP headers sent with requests to this server */
    headers?: SiteMcpServerHeaders;
  };
  RequestHeaders: {};
  ResponseBody: SiteMcpServer;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/mcp-servers/{siteMcpServerId}",
  method: "patch",
  streaming: false,
  tags: ["site-mcp-servers"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags site-mcp-servers
 * @name DeleteSiteMcpServerById
 * @summary Delete a site MCP server
 * @request DELETE:/orgs/{organizationId}/sites/{siteId}/mcp-servers/{siteMcpServerId}
 * @secure
 */

// @ts-ignore
export const deleteSiteMcpServerById: {
  route: string;
  method: "delete";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the site */
    siteId: string;
    /** The unique id of the MCP server */
    siteMcpServerId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/mcp-servers/{siteMcpServerId}",
  method: "delete",
  streaming: false,
  tags: ["site-mcp-servers"],
  criticalityLevel: "low",
  deprecated: false,
};
